import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SchoolService } from "../../../../shared/services/school.service";
import { GroupsService } from "../../services/groups.service";

@Component({
	selector: "app-add-dynamic-group",
	templateUrl: "./add-dynamic-group.component.html",
	styleUrls: ["./add-dynamic-group.component.css", "../../groups.css"],
})
export class AddDynamicGroupComponent implements OnInit {
	constructor(
		private schoolService: SchoolService,
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private groupService: GroupsService
	) {}

	ngOnInit(): void {
		//Get Data (SchoolID, EventDescShort)
		this.selectedDetails.SchoolID = this.dialogConfig.data.SchoolID;
		this.selectedDetails.EventDescShort = this.dialogConfig.data.EventDescShort;
		this.selectedDetails.EventDescriptionID = this.dialogConfig.data.EventDescriptionID;

		//Load Data from DB
		this.loadSchools();
		// this.loadDynamicGroups();
		// this.loadAlertList();
	}

	///////////////////////////////////
	// Data
	///////////////////////////////////

	Saving: any = false;
	SchoolLoading: any = true;
	GroupLoading: any = true;
	ValueLoading: any = true;
	AlertLoading: any = true;

	selectedDetails = {
		SchoolID: 0, //Load from list
		EventDescShort: "", //Get from parent
		EventDescriptionID: 0, //Get from parent
		DynamicGroupSelectID: 0,
		DynamicValueSelectID: 0,
		AlertSelectID: 0,
		Exclude: false,
	};

	//Dropdowns
	schoolList: any = [];
	dynamicGroupList: any = [];
	dynamicValueList: any = [];
	alertList: any = [];

	errorMessage: any = "";

	///////////////////////////////////

	///////////////////////////////////
	// Load Data
	///////////////////////////////////

	private loadSchools() {
		this.SchoolLoading = true;

		//
		// Include schools the user doesn't have access to?
		// ex. for a basketball game, include any schools in district
		//
		var result = this.schoolService.loadSchoolList("All");
		result.subscribe(
			(response: any) => {
				this.schoolList = response;

				if (this.schoolList.length > 0) {
					this.selectedDetails.SchoolID = this.schoolList[0].SchoolID;
				}

				this.SchoolLoading = false;

				this.loadDynamicGroups();
				this.loadAlertList();
			},
			(error) => {
				this.SchoolLoading = false;
			}
		);
	}

	private loadDynamicGroups() {
		this.GroupLoading = true;

		var result = this.groupService.loadDynamicGroupsList("", 1);
		result.subscribe(
			(response) => {
				this.dynamicGroupList = response;
				// this.onDynamicGroupSelectChange(this.dynamicGroupList[0].DynamicGroupID);
				this.selectedDetails.DynamicGroupSelectID = this.dynamicGroupList[0].DynamicGroupID;

				this.GroupLoading = false;

				this.loadDynamicValues();
			},
			(error) => {
				this.GroupLoading = false;
			}
		);
	}

	//Load Dynamic Value Options based on the dynamic group selected
	loadDynamicValues() {
		this.ValueLoading = true;

		//Get information about the dynamic group
		var entry;
		for (var i = 0; i < this.dynamicGroupList.length; i++) {
			if (this.dynamicGroupList[i].DynamicGroupID == this.selectedDetails.DynamicGroupSelectID) {
				entry = this.dynamicGroupList[i];
				break;
			}
		}

		//Call usp_DynamicGroupItemSelectList
		var result = this.groupService.loadDynamicValuesList("", entry.DynamicGroupSQL, this.selectedDetails.SchoolID);
		result.subscribe(
			(response) => {
				this.dynamicValueList = response;

				if (this.dynamicValueList.length > 0) {
					this.selectedDetails.DynamicValueSelectID = this.dynamicValueList[0].ListID;
				}

				this.ValueLoading = false;
			},
			(error) => {
				this.ValueLoading = false;
			}
		);
	}

	loadAlertList() {
		this.AlertLoading = true;

		var result = this.groupService.loadAssignStudentsAlerts("", this.selectedDetails.SchoolID, 1, 1);
		result.subscribe(
			(response) => {
				this.alertList = response;
				this.alertList.unshift({
					AlertID: -1,
					Message: "No Alert",
				});
				this.selectedDetails.AlertSelectID = this.alertList[0].AlertID;

				this.AlertLoading = false;
			},
			(error) => {
				this.AlertLoading = false;
			}
		);
	}
	///////////////////////////////////

	///////////////////////////////////
	// Buttons
	///////////////////////////////////

	AddGroupUpdateClick() {
		this.Saving = true;

		this.errorMessage = "";

		if (this.dynamicGroupList.length == 0) {
			this.errorMessage = "Select a different dynamic group";
			this.Saving = false;
			return;
		} else if (this.dynamicValueList.length == 0) {
			this.errorMessage = "Select a different dynamic value";
			this.Saving = false;
			return;
		} else {
			//Turn exclude into an int
			var exclude = this.selectedDetails.Exclude ? 1 : 0;

			//Call stored procedure
			var result = this.groupService.AddDynamicGroup(
				"",
				this.selectedDetails.EventDescriptionID,
				this.selectedDetails.DynamicGroupSelectID,
				this.selectedDetails.SchoolID,
				this.selectedDetails.DynamicValueSelectID,
				this.selectedDetails.AlertSelectID,
				exclude
			);
			result.subscribe(
				(response) => {
					this.Saving = false;

					this.CancelAddGroupClick(1);
				},
				(error) => {
					this.Saving = false;
				}
			);
		}
	}

	CancelAddGroupClick(val) {
		this.ref.close(val);
	}

	///////////////////////////////////

	///////////////////////////////////
	// Events
	///////////////////////////////////

	onSchoolChange(val) {
		this.errorMessage = "";

		this.selectedDetails.SchoolID = val;

		this.loadDynamicGroups();
		this.loadAlertList();
	}

	onDynamicGroupSelectChange(value) {
		this.errorMessage = "";

		this.selectedDetails.DynamicGroupSelectID = value;
		this.loadDynamicValues();
	}

	///////////////////////////////////
}
